import apiClient from "./apiClient";
import { BillingPlansResponse } from "../models/ResponseModels/BillingPlanResponse";

export type MonriPaymentForm = {
  action: string;
  method: "POST";
  fields: Record<string, string | number>;
};

export type CheckoutSessionResponse = {
  checkout_url?: string;
  payment?: MonriPaymentForm;
  order?: {
    id: number;
    order_number: string;
    status: string;
  };
};

export const getBillingPlansRequest =
  async (): Promise<BillingPlansResponse> => {
    const response = await apiClient.get("/billing/plans");
    return response.data?.data || { plans: [] };
  };

export const createCheckoutSessionRequest = async (
  subscriptionPriceId: number,
): Promise<CheckoutSessionResponse> => {
  const response = await apiClient.post("/billing/checkout", {
    subscription_price_id: subscriptionPriceId,
  });

  return response.data?.data || response.data;
};

export const getCurrentBillingRequest = async () => {
  const response = await apiClient.get("/billing/current");
  return response.data;
};
